import React, {useEffect, useState} from "react";
import {Button, Card, CardContent, Chip, CircularProgress, Grid} from "@material-ui/core";
import {useTheme} from "@material-ui/styles";
import IFrame from '../../components/Iframe/IFrame'
import _ from "lodash"
// styles
import useStyles from "./styles";

// components
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import {Typography} from "../../components/Wrappers/Wrappers";
import {connect} from "react-redux";
import {loadStatisticsForOneJob} from "../../datamanagement/actions";
import {useParams} from "react-router-dom";
import {format_date} from "../../utils";
import withWidth from '@material-ui/core/withWidth';
import ApplicantTable from "./components/ApplicantTable/ApplicantTable";
import JobDashboardModal from "./components/JobDashboardModal/JobDashboardModal"
import Statistiken from "./components/Statistiken/Statistiken"
import Metadaten from "./components/Metadaten/Metadaten"
import Webseitenaufrufe from "./components/Webseitenaufrufe/Webseitenaufrufe"
import {CookieSnackbar} from "../../components/CookieSnackbar/CookieSnackbar";
import {IFRAME_BASE_URL} from "../../datamanagement/network";


const JobDashboard = (props) => {
    var classes = useStyles();
    var theme = useTheme();

    let {id} = useParams();

    const sortByDate = (a, b) => new Date(a.impression_date) - new Date(b.impression_date);

    function buildCumulative(data) {
        const impressions = data["impressions"];
        const u_impressions = _.uniqBy(impressions, 'impression_date')
        const sorted = u_impressions.sort(sortByDate);
        const new_array = [];
        sorted.reduce(function (a, b) {
            let newAcc = a + b.count;
            new_array.push({'impressions': newAcc, 'date': new Date(b.impression_date)})
            return newAcc;
        }, 0);
        return new_array;
    }

    const cumulativeView = (data) => {
        return buildCumulative(data);
    };
    const ticks = (data) => {
        const cumulative = buildCumulative(data);
        const max = Math.ceil((Math.max(...cumulative.map(e => e.impressions)) * 1.05) / 100) * 100;
        let ticks = [0, Math.round(max / 4), Math.round(max / 2), Math.round(max * .75), max];
        return ticks;
    };

    const get_current_job = () => {
        let job = false;
        try {
            props.profile.companies.map((e) => {
                return e.jobs.map((_company_job) => {
                    if (_company_job.id.toString() === id) {
                        job = _company_job;
                    }
                    // Because of linter
                    return null
                });
            });
        } catch (e) {

        }
        return job;
    };

    const [modalOpen, setModalOpen] = useState(false)

    const handleModalClose = () => {
        setModalOpen(false)
    }

    const current_job = get_current_job();

    const states = {
        false: "success",
        true: "secondary",
    };

    useEffect(() => {
        if (!props.jobs[id] && !props.jobs_loading) {
            props.loadStatisticsForOneJob(id);
        }
        if (props.jobs_loading) {
            document.title = `Bitte warten...`
        } else {
            document.title = `${current_job.title}`
        }
        window.scrollTo(0, 0)
    }, [id, current_job, props.jobs_loading]);

    const getImpressions = (data) => {
        return Math.max(...buildCumulative(data).map(e => e.impressions))
    }

    const job_types = () => {
        if (!current_job.job_types) {
            return ''
        }
        return current_job.job_types.join(', ')
    }

    let jobLoadingError = false;

    if (props.jobs[id]) {
        jobLoadingError = !!props.jobs[id].error;
    }


    const jobLoadingErrorMessage = () =>
        <>
            <Card>
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        Error
                    </Typography>
                    {(props.jobs[id].error) ?
                        <Typography variant="body2" color="textSecondary" component="p">
                            {props.jobs[id].error}
                        </Typography> : <br/>
                    }
                </CardContent>
            </Card>
        </>


    if (props.jobs_loading || !props.jobs[id] || !props.profile.companies) {
        return <CircularProgress color="secondary"/>
    }
    if (jobLoadingError) {
        return jobLoadingErrorMessage()
    } else {
        return (
            <>
                <PageTitle title={current_job.title}
                           button={current_job.finished ? '' : <Button
                               variant="contained"
                               size="medium"
                               color="secondary"
                               onClick={() => setModalOpen(true)}
                           >Anpassungen anfragen</Button>}
                           finished={current_job.finished}
                           chip={<Chip label={current_job.finished ? "Offline" : "Online"}
                                       classes={{root: classes[states[current_job.finished]]}}
                                       className={classes.chipMargin}/>}
                />

                <> <Grid className={classes.mainContainer} container spacing={4}>
                    <Grid item xs={12}>
                        <Metadaten classes={classes} currentJob={current_job} jobTypes={job_types()}/>
                    </Grid>
                    <Grid item xs={12}>
                        <Statistiken classes={classes} impressions={getImpressions(props.jobs[id])}
                                     currentJob={current_job}/>
                    </Grid>

                    {(props.jobs[id].likes?.length) ?
                        <Grid item xs={12}>
                            <ApplicantTable color="text" data={props.jobs[id].likes}/>
                        </Grid> : <br/>}


                    <Grid item xs={12}>
                        <Webseitenaufrufe classes={classes} data={cumulativeView(props.jobs[id])}
                                          ticks={ticks(props.jobs[id])} theme={theme}
                                          formatter={(value) => [value, 'Webseitenaufrufe']}
                                          labelFormatter={d => format_date(d)}/>
                    </Grid>
                    <Grid item xs={12}>
                        <Widget
                            disableWidgetMenu
                            title="Ihre Anzeige"
                            upperTitle
                            bodyClass={classes.fullHeightBody}
                            className={classes.card}>
                            <IFrame className={classes.iframe_class} url={`${IFRAME_BASE_URL}/iframe-complete/${id}`}/>
                        </Widget>
                    </Grid>
                </Grid>
                    <JobDashboardModal modalOpen={modalOpen} handleModalClose={handleModalClose} width={props.width}/>
                </>
                <CookieSnackbar/>
            </>)
    }
}


const mapStateToProps = ({profile, jobs, jobs_error, jobs_loading}) => ({jobs, jobs_error, jobs_loading, profile})

const mapDispatchToProps = (dispatch, {history}) => ({loadStatisticsForOneJob: (jobId) => loadStatisticsForOneJob(dispatch, jobId, history)})

export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(JobDashboard));
